var React = require('react');

function Shapes (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm379.51-80l-95-160c-12.67-21.33-44.35-21.33-57 0l-95 160c-12.67 21.33 3.17 48 28.51 48H479c25.34 0 41.18-26.67 28.51-48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 320v160a32 32 0 0 1-32 32H320a32 32 0 0 1-32-32V320a32 32 0 0 1 32-32h160a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

Shapes.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Shapes;

Shapes.default = Shapes;
